import React, { Component } from "react";

/*
The value place will be dynamic and will be picked from message
we will use same for A15 submit
CCS is yet to be done
*/
class MessageA21 extends Component {

    render() {
        let buttonValue      = (this.props.entries && this.props.entries.text) || "";
        return (
            <div className={"s360-message-code-a1-container"}>
                <input className="s360-message-code-a1-button" type='button' value={buttonValue} onClick={this.A1Action} style={this.buttonStyle()} />
            </div>
        )
    }

    buttonStyle = () => {
        return {
            
        }
    }

    A1Action = () => {
      
        // 
    }
}

export default MessageA21;